module.exports = __webpack_public_path__ + "img/source_sw-at01.cc933c9c.png";